import { AnimatePresence, motion } from "framer-motion";
import { X, ArrowUpRight } from "lucide-react";

const isDirectVideo = (u) => !!u && (/\.(mp4|webm|mov|m4v|ogv)(\?|$)/i.test(u) || u.includes("/api/files/"));

export const CreationModal = ({ creation, onClose }) => (
  <AnimatePresence>
    {creation && (
      <motion.div
        data-testid="creation-modal"
        initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
        onClick={onClose}
        className="fixed inset-0 z-[100] bg-black/85 backdrop-blur-xl flex items-center justify-center p-4 md:p-10"
      >
        <motion.div
          initial={{ scale: 0.94, y: 20 }} animate={{ scale: 1, y: 0 }} exit={{ scale: 0.94, y: 20 }}
          transition={{ ease: [0.22, 1, 0.36, 1], duration: 0.4 }}
          onClick={(e) => e.stopPropagation()}
          data-lenis-prevent
          className="relative w-full max-w-4xl bg-card border border-border max-h-[90vh] overflow-y-auto overscroll-contain"
        >
          <button
            data-testid="creation-modal-close"
            onClick={onClose}
            className="absolute top-4 right-4 z-10 w-10 h-10 flex items-center justify-center bg-black/60 border border-white/20 hover:bg-volt hover:text-white transition-colors duration-200"
          >
            <X className="w-4 h-4" />
          </button>

          <div className="aspect-video w-full bg-black">
            {creation.media_type === "video" && creation.video_url ? (
              isDirectVideo(creation.video_url) ? (
                <video data-testid="creation-video-player" src={creation.video_url} controls autoPlay playsInline className="w-full h-full object-contain bg-black" />
              ) : (
                <iframe title={creation.title} src={creation.video_url} className="w-full h-full" allowFullScreen frameBorder="0" />
              )
            ) : (
              <img src={creation.image_url} alt={creation.title} className="w-full h-full object-cover" />
            )}
          </div>

          <div className="p-6 md:p-10">
            <span className="font-mono text-[10px] tracking-[0.2em] uppercase text-volt">{creation.game}</span>
            <h3 className="font-display font-extrabold text-3xl tracking-tight uppercase mt-2">{creation.title}</h3>
            <p className="text-muted-foreground mt-4 leading-relaxed max-w-2xl">{creation.description}</p>
            {creation.external_url && (
              <a
                href={creation.external_url} target="_blank" rel="noreferrer"
                data-testid="creation-external-link"
                className="inline-flex items-center gap-2 mt-6 font-mono text-xs tracking-[0.2em] uppercase bg-volt text-white px-5 py-3 hover:brightness-110 transition-all duration-200"
              >
                View Project <ArrowUpRight className="w-4 h-4" />
              </a>
            )}
          </div>
        </motion.div>
      </motion.div>
    )}
  </AnimatePresence>
);
